import "./Photos.css";

export default function Photos(props) {
console.log(props.photos)
   if (props.photos) { 
        return <section className="Photos">
            <div className="row img-style">
            {props.photos.map(function(photo, index) {
                return ( 
                    <div className="col-4" key={index}>
                        <a href={photo.url} target="_blank" rel="noreferrer">
                    <img src={photo.src.landscape} alt="dictionary word" className="img-fluid" />
                    </a>
                    </div>
                )
            })} </div>
        </section>
   } else {
    return null;
   }
}